import _ from "lodash";
import { Helmet } from "react-helmet";
import { connect, useSelector } from "react-redux";
import configuration from "../../utils/configuration";
import {
  getPageTitle,
  getSiteIcon,
  getSiteName,
  persistBrandFromConfig,
  resetBrandingCache,
} from "../../utils/brandingConfig";
import React, { Component, lazy, Suspense } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { setTranslations, setLanguage } from "react-multi-lang";
import { createBrowserHistory, createMemoryHistory } from "history";

import Loader from './Loader'
import api from '../../Environment';
import MainLayout from '../layouts/MainLayout';
import AuthLayout from '../layouts/AuthLayout';
import LiveLayout from '../layouts/LiveLayout';
import StoryLayout from '../layouts/StoryLayout';
import NewHeader from '../layouts/Header/NewHeader';
import { apiConstants } from "../Constant/constants";
import RegisterLayout from '../layouts/RegisterLayout';
import Face2FaceLayout from '../layouts/Face2FaceLayout'
import DomainMigrationBanner from '../layouts/DomainMigrationBanner';
import MainLandingPage from '../LandingPageIndex/MainLandingPage';
import { SocketContext } from "../../helpers/contexts/communication";
import { setInitialThemeMode } from "../../store/actions/ThemeAction";
import { isAuthenticated, clearCredentials } from "../../helpers/authentication/authentication";
import { fetchUserConfigurationsStart } from "../../store/actions/UserConfigurationsAction";
import { applyCachedFavicon, applyFaviconFromConfig } from "../../helpers/favicon";

import "../Base/Loader.css";
import en from "../translations/en.json";
import es from "../translations/es.json";

const SubscribersIndex = lazy(async () => await import('../Subscriptions/SubscribersIndex'));
const SubscriptionsIndex = lazy(async () => await import('../Subscriptions/SubscriptionsIndex'));
const FollowingIndex = lazy(async () => await import('../Accounts/FansFollowing/Following/FollowingIndex'));
const Face2Face = lazy(async () => await import('../Face2Face/Face2Face'));
const CallingF2F = lazy(async () => await import('../Face2Face/pages/CallingF2F'));
const UserCallingF2f = lazy(async () => await import('../Face2Face/pages/UserCallingF2F'));
const UploadProfilePicture = lazy(async () => await import('../Accounts/Profile/UploadProfilePicture'));
const BillingAccountIndex = lazy(async () => await import('../Accounts/Payments/BillingAccountIndex'));
const DocumentUploadIndex = lazy(async () => await import('../DocumentUpload/DocumentUploadIndex'));
const GoLiveStreamingWatch = lazy(async () => await import('../Stream/Live/GoLiveStreamingWatch'));
const LandingPageIndex = lazy(async () => await import('../LandingPageIndex/LandingPageIndex'));
const NotificationIndex = lazy(async () => await import('../Notification/NotificationIndex'));
const FavoritesIndex = lazy(async () => await import('../Accounts/Favorites/FavoritesIndex'));
const CreatePostIndex = lazy(async () => await import('../Post/CreatePost/CreatePostIndex'));
const CreateAdsIndex = lazy(async () => await import('../Ads/pages/CreateAdCampaign'));
const AdsIndex = lazy(async () => await import('../Ads/pages/Ads'));
const AdCampaignDetail = lazy(async () => await import('../Ads/pages/AdCampaignDetail'));
const FanIndex = lazy(async () => await import('../Accounts/FansFollowing/Fans/FanIndex'));
const ResetPassword = lazy(async () => await import('../LandingPageIndex/ResetPassword'));
const SettingIndex = lazy(async () => await import('../Accounts/Settings/SettingIndex'));
const BankingIndex = lazy(async () => await import('../Accounts/Payments/BankingIndex'));
const GoLiveStreaming = lazy(async () => await import('../Stream/Live/GoLiveStreaming'));
const ProfileIndex = lazy(async () => await import('../Accounts/Profile/ProfileIndex'));
const TermsOfServices = lazy(async () => await import('../StaticPage/TermsOfServices'));
const ContentModerationPolicy = lazy(async () => await import('../StaticPage/ContentModerationPolicy'));
const ContentRemovalPolicy = lazy(async () => await import('../StaticPage/ContentRemovalPolicy'));
const PerformerAgreement = lazy(async () => await import('../StaticPage/PerformerAgreement'));
const ComplaintPolicy = lazy(async () => await import('../StaticPage/ComplaintPolicy'));
const BecomeAPerformer = lazy(async () => await import('../Accounts/BecomeAPerformer'));
const BookmarksIndex = lazy(async () => await import('../Bookmarks/BookmarksIndex'));
const PerformerProfile = lazy(() => import('../Model/PerformerProfile/PerformerProfile'));
const LivePage = lazy(async () => await import('../../components/Stream/LivePage'));
const Signup = lazy(async () => await import('../LandingPageIndex/Signup/Signup'));
const BookmarkVideo = lazy(async () => await import('../Bookmarks/BookmarkVideo'));
const BookmarkPhoto = lazy(async () => await import('../Bookmarks/BookmarkPhoto'));
const ErrorPage = lazy(async () => await import('../Pages/ErrorPages/ErrorPage'));
const MaintenancePage = lazy(async () => await import('../Pages/ErrorPages/Maintenance'));
const Helpandsupport = lazy(async () => await import('../Pages/Helpandsupport'));
const BillingSupport = lazy(async () => await import('../Pages/BillingSupport'));
const VipIndex = lazy(async () => await import('../Accounts/Viproom/VipIndex'));
const MessageIndex = lazy(async () => await import('../Messages/MessageIndex'));
const Privacypolicy = lazy(async () => await import('../Pages/Privacypolicy'));
const ListIndex = lazy(async () => await import('../Accounts/List/ListIndex'));
const HomePageIndex = lazy(async () => await import('../Home/HomePageIndex'));
const StaticPage = lazy(async () => await import('../StaticPage/StaticPage'));
const SearchIndex = lazy(async () => await import('../Search/SearchIndex'));
const Verify = lazy(async () => await import('../LandingPageIndex/Verify'));
const Howitworks = lazy(async () => await import('../Pages/Howitworks'));
const Contactus = lazy(async () => await import('../Pages/Contactus'));
const Stories = lazy(async () => await import('../Stories/Stories'));
const PostView = lazy(async () => await import('../Post/PostView'));
const Logout = lazy(async () => await import('../Accounts/Logout'));
const HubIndex = lazy(async () => await import('../Hub/HubIndex'));
const AboutUs = lazy(async () => await import('../Pages/AboutUs'));
const Reffer = lazy(async () => await import('../Pages/Reffer'));
const Usc = lazy(async () => await import('../StaticPage/Usc'));
const Error = lazy(async () => await import('../Pages/ErrorPages/Error'));
const CancellationPolicy = lazy(async () => await import('../Pages/CancellationPolicy'));
const RefundPolicy = lazy(async () => await import('../Pages/RefundPolicy'));
const VideoStore = lazy(async () => await import('../VideoStore'));

setTranslations({ en, es });

const AppRoute = ({
  title,
  component: Component,
  layout: Layout,
  screenProps: ScreenProps,
  ...rest
}) => (
  <Suspense fallback={
    <Layout screenProps={ScreenProps}>
      <></>
    </Layout>
  }>
    <Layout screenProps={ScreenProps}>
      <Component title={title} />
    </Layout>
  </Suspense>
);

const PrivateRoute = ({
  title,
  component: Component,
  layout: Layout,
  screenProps: ScreenProps,
  authState,
  ...rest
}) => {
  const profile = useSelector((state) => state.users.profile);

  const isEmailUnverified = () => {
    return (
      !profile.loading &&
      !_.isEmpty(profile.data) &&
      !profile.data.is_email_verified
    );
  };

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  
  if (isEmailUnverified()) {
    return <Navigate to="/verify" replace />;
  }

  return (
    <Suspense fallback={
      <Layout screenProps={ScreenProps}>
        <></>
      </Layout>
    }>
      <Layout screenProps={ScreenProps}>
        <Component authRoute={true} title={title} />
      </Layout>
    </Suspense>
  );
};

const PublicRoute = ({
  title,
  layout: Layout,
  component: Component,
  screenProps: ScreenProps,
  ...rest
}) => {
  const navigate = useNavigate();

  return (
    <Suspense fallback={
      <Layout screenProps={ScreenProps}>
        <></>
      </Layout>
    }>
      <Layout screenProps={ScreenProps}>
        <Component authRoute={true} title={title} />
      </Layout>
    </Suspense>
  );
};

class App extends Component {
  static contextType = SocketContext;
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      configLoading: true,
      loadTime: true,
    };

    // If we're on Google translate domain, we need to patch the BrowserRouter's links to behave as
    // normal HTML anchors instead of using location.pushState. This is because Google translate
    // will change the page's domain, and the browser will not allow cross-domain scripted navigation.
    // Hence, we will solve this by using createMemoryHistory & by ignoring pushState just for translate.goog domain
    const createHistory =
      typeof window !== 'undefined' && window.location.href.includes('translate.goog')
        ? createMemoryHistory
        : createBrowserHistory;

    const history = createHistory();

    history.listen((location, action) => {
      this.setState({
        authentication: isAuthenticated(),
      });
      document.body.scrollTop = 0;
    });

    setTimeout(() => {
      this.setState({ loadTime: false });
    }, 5000);
  }

  componentDidMount() {
    this.bootApp();
    let userLanguage = localStorage.getItem("lang")
      ? localStorage.getItem("lang")
      : "en";
    localStorage.setItem("lang", userLanguage);
    setLanguage(userLanguage);
    this.props.dispatch(setInitialThemeMode());
    this.props.dispatch(fetchUserConfigurationsStart());
  }

  async bootApp() {
    await this.fetchConfig();
    await this.checkIfTokenIsValid();
  }

  async fetchConfig() {
    try {
      const response = await fetch(apiConstants.settingsUrl);
      const configValue = await response.json();

      configuration.set({ configData: configValue.data }, { freeze: false });
      persistBrandFromConfig(configValue.data);
      resetBrandingCache();
      applyFaviconFromConfig(configValue.data);
      this.setState({ configLoading: false, loadTime: false });
      if (configValue?.data?.SITE_UNDER_MAINTENANCE == 1) {
        if (!window.location.pathname.includes("maintenance")) {
          window.location.href = "/maintenance"
        }
      }
    } catch (error) {
      configuration.set({ configData: [] }, { freeze: false });
      resetBrandingCache();
      applyCachedFavicon();
      this.setState({ configLoading: false, loadTime: false });
    }
  }

  async checkIfTokenIsValid() {
    try {
      if (isAuthenticated()) {
        let response = await api.postMethod('is_valid_authorization_token', {});

        if (!response.data.success) {
          clearCredentials()
        }

      } else if (!(/^\/user\/[a-zA-Z0-9_-]+$/.test(window.location.pathname))) {
        clearCredentials()
      }

      this.setState({
        loading: false
      })
    } catch (error) {
      this.setState({
        loading: false
      })
    }
  }

  render() {
    const isLoading = this.state.configLoading;
    const loadTime = this.state.loadTime;
    const errorComponent = this.props.errorComponent;
    if (isLoading) {
      return <></>;
    }

    if (loadTime || this.state.loading) {
      if (window.location.pathname === "/") {
        return <></>;
      }

      return <Loader />;
    }

    return (
      <>
        <DomainMigrationBanner />
        <Helmet>
          <meta property="og:site_name" content={getSiteName()} />
          {getSiteIcon() ? (
            <link
              aria-label='site favicon'
              rel="icon"
              type="image/png"
              href={getSiteIcon()}
            />
          ) : null}
        </Helmet>
        <Routes>

          <Route
            path="/"
            element={<PublicRoute
              title={getPageTitle("Timeline")}
              component={HomePageIndex}
              layout={MainLayout}
            />}
          />

          <Route path="/home" element={<Navigate to="/" replace />} />

          <Route
            path="/login"
            element={<AppRoute
              title={getPageTitle("!")}
              component={errorComponent?.show ? Error : MainLandingPage}
              layout={AuthLayout}
            />}
          />

          <Route
            path="/sign-in"
            element={<AppRoute
              title={getPageTitle("Verify")}
              component={errorComponent?.show ? Error : Verify}
              layout={AuthLayout}
            />}
          />

          <Route
            path="/register"
            element={<AppRoute
              title={getPageTitle("Register")}
              component={errorComponent?.show ? Error : Signup}
              layout={RegisterLayout}
            />}
          />
          <Route
            path="/verify"
            element={<AppRoute
              title={getPageTitle("Verify")}
              component={errorComponent?.show ? Error : Verify}
              layout={AuthLayout}
            />}
          />

          <Route
            path="/become-performer"
            element={<PrivateRoute
              title={getPageTitle("Become a Performer")}
              component={BecomeAPerformer}
              layout={MainLayout}
            />}
          />

          <Route
            path="/inbox"
            element={<PrivateRoute
              title={getPageTitle("Inbox")}
              component={MessageIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/posts-create"
            element={<PrivateRoute
              title={getPageTitle("Create Post")}
              component={CreatePostIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/post/:post_unique_id"
            element={<PublicRoute
              title={getPageTitle("Post")}
              component={PostView}
              layout={MainLayout}
            />}
          />

          <Route
            path="/ads"
            element={<PrivateRoute
              title={getPageTitle("Ads")}
              component={AdsIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/create-ad-campaign"
            element={<PrivateRoute
              title={getPageTitle("Create Ad Campaign")}
              component={CreateAdsIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/ads-view/:id"
            element={<PrivateRoute
              title={getPageTitle("View Ads")}
              component={AdCampaignDetail}
              layout={MainLayout}
            />}
          />

          <Route
            path="/bookmarks"
            element={<PrivateRoute
              title={getPageTitle("Bookmarks")}
              component={BookmarksIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/bookmark-photo"
            element={<PrivateRoute
              title={getPageTitle("Bookmark Photo")}
              component={BookmarkPhoto}
              layout={MainLayout}
            />}
          />

          <Route
            path="/bookmark-video"
            element={<PrivateRoute
              title={getPageTitle("Bookmark Video")}
              component={BookmarkVideo}
              layout={MainLayout}
            />}
          />

          <Route
            path="/following"
            element={<PrivateRoute
              title={getPageTitle("Following")}
              component={FollowingIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/fans"
            element={<PrivateRoute
              title={getPageTitle("Fans")}
              component={FanIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/favorites"
            element={<PrivateRoute
              title={getPageTitle("Favorites")}
              component={FavoritesIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/subscribers"
            element={<PrivateRoute
              title={getPageTitle("Subscribers")}
              component={SubscribersIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/subscriptions"
            element={<PrivateRoute
              title={getPageTitle("Subscriptions")}
              component={SubscriptionsIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/list"
            element={<PrivateRoute
              title={getPageTitle("List")}
              component={ListIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/edit-profile"
            element={<PrivateRoute
              title={getPageTitle("Edit Profile")}
              component={SettingIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/settings/account"
            element={<PrivateRoute
              title={getPageTitle("Account Settings")}
              component={SettingIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/settings/security"
            element={<PrivateRoute
              title={getPageTitle("Security Settings")}
              component={SettingIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/settings/notification"
            element={<PrivateRoute
              title={getPageTitle("Notification Settings")}
              component={SettingIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/settings/privacy-policy"
            element={<PrivateRoute
              title={getPageTitle("Privacy Policy")}
              component={SettingIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/settings/theme-language"
            element={<PrivateRoute
              title={getPageTitle("Theme Settings")}
              component={SettingIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/settings/subscriptions"
            element={<PrivateRoute
              title={getPageTitle("Subscriptions Settings")}
              component={SettingIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/settings/profile-visibility"
            element={<PrivateRoute
              title={getPageTitle("Profile Visibility")}
              component={SettingIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/settings/tracking-links"
            element={<PrivateRoute
              title={getPageTitle("Tracking Links")}
              component={SettingIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/settings/whats-new"
            element={<PrivateRoute
              title={getPageTitle("What's new")}
              component={SettingIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/settings"
            element={<PrivateRoute
              title={getPageTitle("Settings")}
              component={SettingIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/vip-room"
            element={<PrivateRoute
              title={getPageTitle("VIP Rooms")}
              component={VipIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/profile"
            element={<PrivateRoute
              title={getPageTitle("My Profile")}
              component={ProfileIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/notification"
            element={<PrivateRoute
              title={getPageTitle("Notification")}
              component={NotificationIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/billing-accounts"
            element={<PrivateRoute
              title={getPageTitle("Billing Accounts")}
              component={BillingAccountIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/cards/:id/edit"
            element={<PrivateRoute
              title={getPageTitle("Edit Cards")}
              component={HubIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/cards/verification_document"
            element={<PrivateRoute
              title={getPageTitle("Card Verification")}
              component={HubIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/cards"
            element={<PrivateRoute
              title={getPageTitle("Cards")}
              component={HubIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/add-card"
            element={<PrivateRoute
              title={getPageTitle("Add Card")}
              component={HubIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/wallet/payouts"
            element={<PrivateRoute
              title={getPageTitle("Wallet Payouts")}
              component={HubIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/referrals"
            element={<PrivateRoute
              title={getPageTitle("Referrals")}
              component={HubIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/banking"
            element={<PrivateRoute
              title={getPageTitle("Banking")}
              component={BankingIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/wallet"
            element={<PrivateRoute
              title={getPageTitle("Wallet")}
              component={HubIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/statement"
            element={<PrivateRoute
              title={getPageTitle("Statement")}
              component={HubIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/alternative-method"
            element={<PrivateRoute
              title={getPageTitle("Alternate Method")}
              component={HubIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/document-upload"
            element={<PrivateRoute
              title={getPageTitle("Doc Upload")}
              component={DocumentUploadIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/search"
            element={<AppRoute
              title={getPageTitle("Search")}
              component={SearchIndex}
              layout={MainLayout}
            />}
          />

          <Route
            path="/reset-password/:token"
            element={<AppRoute
              title={getPageTitle("Reset Password")}
              component={ResetPassword}
              layout={AuthLayout}
            />}
          />

          <Route
            path="/upload-profile-picture"
            element={<PrivateRoute
              title={getPageTitle("Upload Profile Picture")}
              component={UploadProfilePicture}
              layout={MainLayout}
            />}
          />

          <Route
            path="/logout"
            element={<PrivateRoute
              component={Logout}
              layout={MainLayout}
            />}
          />

          <Route
            path="/call-f2f"
            element={<PrivateRoute
              title={getPageTitle("Face2face")}
              component={CallingF2F}
              layout={Face2FaceLayout}
            />}
          />

          <Route
            path="/user-call-f2f"
            element={<PrivateRoute
              title={getPageTitle("Face2face")}
              component={UserCallingF2f}
              layout={Face2FaceLayout}
            />}
          />

          <Route
            path="/golive/:id/watch"
            element={<PrivateRoute
              title={getPageTitle("Watch Go Live")}
              component={GoLiveStreamingWatch}
              layout={LiveLayout}
            />}
          />

          <Route
            path="/golive/:id/streamer"
            element={<PrivateRoute
              title={getPageTitle("Stream Go Live")}
              component={GoLiveStreaming}
              layout={LiveLayout}
            />}
          />

          <Route
            path="/live"
            element={<PrivateRoute
              title={getPageTitle("Live")}
              component={LivePage}
              layout={MainLayout}
            />}
          />

          <Route
            path="/face2face"
            element={<PrivateRoute
              title={getPageTitle("Face2face")}
              component={Face2Face}
              layout={MainLayout}
            />}
          />

          <Route
            path="/stories"
            element={<PrivateRoute
              title={getPageTitle("Stories")}
              component={Stories}
              layout={StoryLayout}
            />}
          />

          <Route
            path="/user/:username"
            element={<PublicRoute
              component={PerformerProfile}
              layout={MainLayout}
            />}
          />

          <Route
            path="/video-store"
            element={<PublicRoute
              title={getPageTitle("Video Store")}
              component={VideoStore}
              layout={MainLayout}
            />} 
          />

          <Route 
            path="/privacy-policy" 
            element={errorComponent?.show ? <ErrorPage /> : <Privacypolicy title={getPageTitle("Privacy Policy")} />}
          />

          <Route 
            path="/USC-2257" 
            element={errorComponent?.show ? <ErrorPage /> : <Usc title={getPageTitle("USC-2257")} />}
          />

          <Route 
            path="/referral" 
            element={errorComponent?.show ? <ErrorPage /> : <Reffer title={getPageTitle("Referrals")} />}
          />

          <Route 
            path="/how-it-works" 
            element={errorComponent?.show ? <ErrorPage /> : <Howitworks title={getPageTitle("How it Works")} />}
          />

          <Route 
            path="/contact-us" 
            element={<Contactus title={getPageTitle("Contact Us")} />}
          />

          <Route 
            path="/help-and-support" 
            element={errorComponent?.show ? <ErrorPage /> : <PublicRoute
              title={getPageTitle("Help & Support")}
              component={Helpandsupport}
              layout={MainLayout}
            />}
          />

          <Route 
            path="/Terms-of-Services" 
            element={errorComponent?.show ? <ErrorPage /> : <TermsOfServices title={getPageTitle("ToS")} />}
          />

          <Route 
            path="/content-moderation-policy"
            element={errorComponent?.show ? <ErrorPage /> : <ContentModerationPolicy title="Content Moderation Policy" />}
          />

          <Route 
            path="/content-removal-policy"
            element={errorComponent?.show ? <ErrorPage /> : <ContentRemovalPolicy title="Content Removal Policy" />}
          />

          <Route 
            path="/performer-agreement"
            element={errorComponent?.show ? <ErrorPage /> : <PerformerAgreement title="Performer Agreement" />}
          />

          <Route 
            path="/complaint-policy"
            element={errorComponent?.show ? <ErrorPage /> : <ComplaintPolicy title="Complaint Policy" />}
          />

          <Route 
            path="/support/billing" 
            element={errorComponent?.show ? <ErrorPage /> : <BillingSupport title={getPageTitle("Billing Support")} />}
          />

          <Route 
            path="/about" 
            element={<AboutUs title={getPageTitle("About Us")} />}
          />

          <Route 
            path="/cancellation-policy" 
            element={<CancellationPolicy title={getPageTitle("Cancellation Policy")} />}
          />

          <Route 
            path="/refund-policy" 
            element={<RefundPolicy title={getPageTitle("Refund Policy")} />}
          />

          <Route 
            path="/error/:code" 
            element={<ErrorPage />}
          />

          <Route 
            path="/maintenance" 
            element={<MaintenancePage />}
          />

          <Route 
            path="*" 
            element={<ErrorPage />}
          />


        </Routes>
      </>
    );
  }
}
const mapStateToPros = (state) => ({
  errorComponent: state.component.errorComponent
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(App);
